var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"carrier d-flex pr-4"},[_c('img',{staticClass:"carrier__logo",attrs:{"src":require(`@img/couriers/courier-${_vm.getCarrierLogoCode(_vm.item.carrierCode, _vm.item.selectedService || '')}.svg`),"alt":_vm.item.carrierCode,"width":"45","height":"45"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }